export default __webpack_public_path__ + "static/media/diagonal-lines.da4b822f.jpg";